import { compose } from "lodash/fp";
import { action, observable } from "mobx";

import { INQUIRY_TYPES, traits } from "../../../interested-seller-inquiry";
import { withHomeClaimModal, withValuationContent } from "../../traits";

const { withSellerInquiryModal } = traits;

const enhance = compose(
  withHomeClaimModal,
  withValuationContent,
  withSellerInquiryModal
);

class UIStore {
  @observable showMinimalComponentTreatment = false;
  @observable sellerInquiryType = INQUIRY_TYPES.streeteasy_valuation;

  constructor({ analyticsService }) {
    this.analyticsService = analyticsService;

    this.setHomeClaimModalObservers();
    this.setInterestedSellerInquiryModalObservers();
  }

  @action.bound
  initialize({ showMinimalComponentTreatment }) {
    this.setShowMinimalComponentTreatment(showMinimalComponentTreatment);
  }

  @action.bound
  setShowMinimalComponentTreatment(value) {
    this.showMinimalComponentTreatment = value;
  }
}

export default enhance(UIStore);
